var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Footer",class:{
        'Footer--desktop': !_vm.isMobile,
        'Footer--home': _vm.$route.path === '/',
        'Footer--results': _vm.$route.path === '/calculate_results' || _vm.$route.path === '/find_results'
    }},[_c('div',{staticClass:"Footer-divider"}),_c('span',{staticClass:"Footer-text"},[_vm._v(_vm._s(_vm.footerText))])])}
var staticRenderFns = []

export { render, staticRenderFns }